export default __webpack_public_path__ + "static/media/60.186f3584.png";